module.exports = __webpack_public_path__ + "static/media/d-edge.adb7c6db.ico";